export default __webpack_public_path__ + "static/media/profits.04b1c713.png";